const config={
	flagList:[{
					colorId:0,
					checked:false,
					desc:'',
					flagId:null,
					style:{
					'display': 'inline-block',
					'background-color': '#FF5340',
					'width': '20px',
					'height': '20px',
					'border-radius': '5px'
				    }
				},{
					colorId:1,
					checked:false,
					desc:'',
					flagId:null,
					style:{
					'display': 'inline-block',
					'background-color': '#409EFF',
					'width': '20px',
					'height': '20px',
					'border-radius': '5px'
				    }
				},{
					colorId:2,
					checked:false,
					desc:'',
					flagId:null,
					style:{
					'display': 'inline-block',
					'background-color': '#FF9640',
					'width': '20px',
					'height': '20px',
					'border-radius': '5px'
				    }
				},{
					colorId:3,
					checked:false,
					desc:'',
					flagId:null,
					style:{
					'display': 'inline-block',
					'background-color': '#D9FF40',
					'width': '20px',
					'height': '20px',
					'border-radius': '5px'
				    }
				},{
					colorId:4,
					checked:false,
					desc:'',
					flagId:null,
					style:{
					'display': 'inline-block',
					'background-color': '#40BFFF',
					'width': '20px',
					'height': '20px',
					'border-radius': '5px'
				    }
				},{
					colorId:5,
					checked:false,
					desc:'',
					flagId:null,
					style:{
					'display': 'inline-block',
					'background-color': '#4069FF ',
					'width': '20px',
					'height': '20px',
					'border-radius': '5px'
				    }
				},{
					colorId:6,
					checked:false,
					desc:'',
					flagId:null,
					style:{
					'display': 'inline-block',
					'background-color': '#A640FF ',
					'width': '20px',
					'height': '20px',
					'border-radius': '5px'
				    }
				},{
					colorId:7,
					checked:false,
					desc:'',
					flagId:null,
					style:{
					'display': 'inline-block',
					'background-color': '#FF4053',
					'width': '20px',
					'height': '20px',
					'border-radius': '5px'
				    }
				},{
					colorId:8,
					checked:false,
					desc:'',
					flagId:null,
					style:{
					'display': 'inline-block',
					'background-color': '#E6FF40',
					'width': '20px',
					'height': '20px',
					'border-radius': '5px'
				    }
				},{
					colorId:9,
					checked:false,
					desc:'',
					flagId:null,
					style:{
					'display': 'inline-block',
					'background-color': '#40C6FF',
					'width': '20px',
					'height': '20px',
					'border-radius': '5px'
				    }
				},{
					colorId:10,
					checked:false,
					desc:'',
					flagId:null,
					style:{
					'display': 'inline-block',
					'background-color': '#9340FF',
					'width': '20px',
					'height': '20px',
					'border-radius': '5px'
				    }
				},{
					colorId:11,
					checked:false,
					desc:'',
					flagId:null,
					style:{
					'display': 'inline-block',
					'background-color': '#FF404D',
					'width': '20px',
					'height': '20px',
					'border-radius': '5px'
				    }
				},{
					colorId:12,
					checked:false,
					desc:'',
					flagId:null,
					style:{
					'display': 'inline-block',
					'background-color': '#50FF40',
					'width': '20px',
					'height': '20px',
					'border-radius': '5px'
				    }
				},{
					colorId:13,
					checked:false,
					desc:'',
					flagId:null,
					style:{
					'display': 'inline-block',
					'background-color': '#99FF40 ',
					'width': '20px',
					'height': '20px',
					'border-radius': '5px'
				    }
				},{
					colorId:14,
					checked:false,
					desc:'',
					flagId:null,
					style:{
					'display': 'inline-block',
					'background-color': '#8640FF',
					'width': '20px',
					'height': '20px',
					'border-radius': '5px'
				    }
				}],
}
				
export default config		